var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.getCommonSyncString("selectFacilityTitle"),
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
        submitDisabled: !_vm.selectedId,
      },
      on: {
        submit: _vm.handleSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _vm._t("description", function () {
        return [_vm._v("\n    " + _vm._s(_vm.deviceInfoMsg) + "\n  ")]
      }),
      _c("RadioButtonGroup", {
        attrs: {
          items: _vm.facilities,
          currentValue: _vm.selectedId,
          itemLabel: function (fac) {
            return _vm.formatNameAndId(fac.name, fac.id)
          },
          itemValue: function (fac) {
            return fac.id
          },
        },
        on: {
          "update:currentValue": function ($event) {
            _vm.selectedId = $event
          },
          "update:current-value": function ($event) {
            _vm.selectedId = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }